module.exports = __webpack_public_path__ + "static/IllichRealty-8f2f413f1a928f43c888488123b267d6.png";